export default __webpack_public_path__ + "images/UEPFLY.3b7825c.png";